import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { widgetVersionObj } from '../../../Constants/ProductPage';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import { getDeviceType, getScreenName } from '../../../Utils/helper';
import { getPriceParams } from '../../../Utils/productPageUtils';
import {
  CenterStylePopup,
  customStyles,
  SizeStyles,
} from '../../../Utils/redirections';
import dynamic from 'next/dynamic';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { fireEvent } from '../../../Utils/fireEvent';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});
const SizeChartModal = dynamic(() => import('./SizeChartModal'), {
  ssr: false,
});

export default function SizeChartPopup(props) {
  const {
    varientData,
    clickProductColorHandler,
    productDetail,
    selectedData,
    showSizeChartPopup,
    setShowSizeChartPopup,
    setSizePopupButtons,
  } = props;
  const sizeChartPopup = useRef(null);
  const [Styles, setStyles] = useState(
    getDeviceType() == 'mWeb'
      ? customStyles('', '', '0', '')
      : CenterStylePopup('55%', 'auto', 'auto', '45%'),
  );
  const params = new URLSearchParams(window.location.search);
  const router = useRouter();
  const { pricing_param, conversion_param } = getPriceParams(productDetail);
  const clickProduct = (url, option, selectedAttribute, type, from) => {
    if (selectedAttribute && type) {
      if (getDeviceType() == 'desktop') {
        setStyles(CenterStylePopup('55%', 'auto', 'auto', '45%'));
      } else {
        setStyles(customStyles('', '', '0', ''));
      }
      clickProductColorHandler(
        url,
        option,
        selectedAttribute,
        type,
        from == 'size_chart' ? 'size_chart' : 'select_size',
      );
      setSizePopupButtons(false);
    }
  };
  const closeSizeChartModal = () => {
    fireEvent({
      category: 'discard_popup',
      screen_name: getScreenName(),
      id: productDetail?.nickName,
      pricing_param: pricing_param,
      conversion_param: conversion_param,
      selling_price: productDetail?.price,
      sku_nickname: productDetail?.nickName,
      sku_type: 'product',
      user_type: getWebUserType(),
      page_url: window?.location?.href,
      pdp_variant:
        productDetail?.widgets[0]?.version == widgetVersionObj.aPlusPlus
          ? productDetail?.isfashionReady
            ? 'aplus_plus_fashion_ready'
            : 'aplus_plus'
          : productDetail?.isfashionReady
            ? 'aplus_fashion_ready'
            : 'aplus',
    });
    setShowSizeChartPopup(false);
    params.delete('sizeChartPopup');
    if (window?.history?.length > 2) {
      router.back();
    } else {
      router.replace(
        window.location.pathname.toString() + '?' + params,
        undefined,
        { shallow: true },
      );
    }
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  };
  useEffect(() => {
    if (showSizeChartPopup) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      params.set('sizeChartPopup', 'true');
      router.push(window?.location?.pathname + '?' + params, undefined, {
        shallow: true,
        scroll: false,
      });
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
    setStyles(
      getDeviceType() == 'mWeb'
        ? SizeStyles('', '', '0', '')
        : CenterStylePopup('55%', 'auto', 'auto', '45%'),
    );
    fireEvent({
      category: 'viewed_general_screen',
      screen_name: 'size_chart',
      id: productDetail?.nickName,
      pricing_param: pricing_param,
      conversion_param: conversion_param,
      selling_price: productDetail?.price,
      sku_nickname: productDetail?.nickName,
      sku_type: 'product',
      user_type: getWebUserType(),
      page_url: window?.location?.href,
    });
    return function () {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, [showSizeChartPopup]);

  const handleSizeChartPopup = (url, shallow) => {
    if (!url.includes('sizeChartPopup')) {
      setShowSizeChartPopup(false);
    }
  };
  useRouterChangeStart(handleSizeChartPopup);
  const modalProps = {
    closeSizeChartModal,
    varientData,
    clickProduct,
    productDetail,
    selectedData,
    setShowSizeChartPopup,
  };

  return showSizeChartPopup ? (
    <Modal
      isOpen={showSizeChartPopup}
      style={Styles}
      appElement={sizeChartPopup.current}
    >
      <SizeChartModal {...modalProps} />
    </Modal>
  ) : null;
}
